import { Controller } from "@hotwired/stimulus";

// Rebuilds payroll year hidden fields from year selects; mirrors bulk prefs into the table only when Apply is clicked.
export default class extends Controller {
  static targets = ["payrollYearsContainer"];

  connect() {
    this.form = this.element.closest("form") || this.element;
    this.boundSubmit = () => this.syncPayrollYears();
    this.form.addEventListener("submit", this.boundSubmit);

    this.syncPayrollYears();
    this.mirrorTable();
    this.dispatchSummaryRefresh();
  }

  disconnect() {
    this.form.removeEventListener("submit", this.boundSubmit);
  }

  apply(event) {
    event.preventDefault();
    this.syncPayrollYears();
    this.mirrorTable();
    this.dispatchSummaryRefresh();
  }

  /** Programmatic input changes do not bubble; the summary controller listens on its wrapper. */
  dispatchSummaryRefresh() {
    const summaryEl = this.form.querySelector(
      '[data-controller*="invite-report-prefs-summary"]',
    );
    summaryEl?.dispatchEvent(new Event("change", { bubbles: true }));
  }

  syncPayrollYears() {
    if (!this.hasPayrollYearsContainerTarget) return;

    const sy = parseInt(
      this.form.querySelector("#report_prefs_start_year_bulk")?.value,
      10,
    );
    const ey = parseInt(
      this.form.querySelector("#report_prefs_end_year_bulk")?.value,
      10,
    );

    this.payrollYearsContainerTarget.innerHTML = "";

    if (!Number.isFinite(sy) || !Number.isFinite(ey)) return;

    const min = Math.min(sy, ey);
    const max = Math.max(sy, ey);
    for (let y = min; y <= max; y++) {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "report_prefs[payroll_years][]";
      input.value = String(y);
      this.payrollYearsContainerTarget.appendChild(input);
    }
  }

  mirrorTable() {
    const bulk = this.form.querySelector("#report_prefs_product_bulk");
    const productVal = bulk?.value ?? "";
    this.form.querySelectorAll("[data-row-product]").forEach((el) => {
      el.value = productVal;
    });

    const bulkStart = this.form.querySelector("#report_prefs_start_year_bulk");
    const bulkEnd = this.form.querySelector("#report_prefs_end_year_bulk");
    const startY = bulkStart?.value ?? "";
    const endY = bulkEnd?.value ?? "";

    this.form.querySelectorAll("[data-row-start-year]").forEach((sel) => {
      sel.value = startY;
    });
    this.form.querySelectorAll("[data-row-end-year]").forEach((sel) => {
      sel.value = endY;
    });

    const audBulk = this.form.querySelector("#report_prefs_share_with_auditors_bulk");
    const lwcBulk = this.form.querySelector("#report_prefs_living_wage_contribution_bulk");

    this.form.querySelectorAll("[data-row-auditors]").forEach((el) => {
      el.checked = !!audBulk?.checked;
    });
    this.form.querySelectorAll("[data-row-lwc]").forEach((el) => {
      el.checked = !!lwcBulk?.checked;
    });
  }
}
